import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card007InstagramPosts() {
  return <KbCardPage slug="card-007-instagram-posts" />;
}

(Card007InstagramPosts as unknown as { path: string }).path = "/methodology/007";
